import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { EmployeeAgreementBO, SubmitEmployeeAggremntBo } from './document/document.model';
import { SendToClientBO, SendToEmployeeBO } from './employee-agreement.model';

@Injectable({
  providedIn: 'root'
})
export class EmployeeAgreementService {

  public enableDoc = false
  constructor(private http: HttpClient, public errorService: ErrorService) { }

  saveEmployeeAgreement(agreementBo: EmployeeAgreementBO): Observable<any> {
    let url = "api/EmployeeAgreement/saveEmployeeDocByAgencyUser";
    return this.http.post(url, agreementBo, { observe: 'response', responseType: "text" }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  saveEmployeeAgreementComplete(agreementBo: EmployeeAgreementBO): Observable<any> {
    let url = "api/EmployeeAgreement/saveEmployeeDocumentComplete";
    return this.http.post(url, agreementBo, { observe: 'response', responseType: "text" }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  saveEmployeeDocPortal(agreementBo: EmployeeAgreementBO): Observable<any> {
    let url = "api/Employee_EmployeeAgreement/saveEmployeeDocPortalforEmployee";
    return this.http.post(url, agreementBo, { observe: 'response', responseType: "text" }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  saveEmployeeDocClientPortal(agreementBo: EmployeeAgreementBO): Observable<any> {
    let url = "api/Employee_EmployeeAgreement/saveEmployeeDocPortalforClient";
    return this.http.post(url, agreementBo, { observe: 'response', responseType: "text" }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getEmployeeBio(params: URLSearchParams): Observable<any> {
    let url = "api/EmployeeDetailsRelation/GetEmployeeList?";
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getEmployeeBioPortal(params:URLSearchParams): Observable<any> {
    let url = "api/Employee_EmployeeAgreement/GetEmployeeListForPortal?";
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getClientBio(params: URLSearchParams): Observable<any> {
    let url = "api/EmployeeDetailsRelation/GetClientDetail?";
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getClientBioPortal(): Observable<any> {
    let url = "api/Employee_EmployeeAgreement/GetClientdetailForPortal?";
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  GetEmployeePayrate(params: URLSearchParams): Observable<any> {
    let url = "api/EmployeeDetailsRelation/GetEmployeePayrates?";
    return this.http.get(url + params, { observe: 'response', responseType: "text" }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  GetEmployeePayratePortal(): Observable<any> {
    let url = "api/Employee_EmployeeAgreement/GetEmployeePayratesForPortal?";
    return this.http.get(url, { observe: 'response', responseType: "text" }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  GetEmployeeClientRelationshipData(params: URLSearchParams): Observable<any> {
    let url = "api/EmployeeDetailsRelation/GetEmployeeClientRelationship?";
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  GetEmployeeClientRelationshipDataPortal(): Observable<any> {
    let url = "api/Employee_EmployeeAgreement/GetEmployeeClientRelationshipForPortal?";
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  SentToEmployee(bo: SendToClientBO): Observable<any> {
    let url = "api/EmployeeProcessing/sendToEmployee";
    return this.http.post(url, bo, { observe: 'response', responseType: "text" }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)

    )
  }

  SentToEmployer(bo: SendToEmployeeBO): Observable<any> {
    let url = "api/EmployeeProcessing/sendToClient";
    return this.http.post(url, bo, { observe: 'response', responseType: "text" }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)

    )
  }


  getAgreementDocumentDetails(params: URLSearchParams): Observable<any> {
    let url = "api/EmployeeAgreement/GetEmployeeDocuments?";
    return this.http.get(url + params, { observe: 'response', responseType: "text" }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getAgreementDocumentPoratalDetails(params: URLSearchParams): Observable<any> {
    let url = "api/Employee_EmployeeAgreement/GetEmployeeDocumentsPortal?";
    return this.http.get(url + params, { observe: 'response', responseType: "text" }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  //==============================get employee permission==========================================//
  getpermission(paramsData: URLSearchParams): Observable<any> {
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }




getEmpDocumentList(params:URLSearchParams):Observable<any> {
  let url = "api/EmployeeAgreement/GetEmpDocumentPdfDetails?";
  return this.http.get(url+params, { observe: 'response',responseType: "text" }).pipe(map(data => data.body),
  catchError(this.errorService.handleError)
  )
}

submitEmployeeDocPortal(agreementBo: SubmitEmployeeAggremntBo): Observable<any> {
  let url = "api/Employee_EmployeeAgreement/submitEmployeeDocPortalforEmployee";
  return this.http.post(url, agreementBo, { observe: 'response', responseType: "text" }).pipe(
    map(data => data.body),
    catchError(this.errorService.handleError)
  )
}

  
}
